import * as yup from 'yup';

export const phoneNumberValidation = yup.string()
    .matches(/^\d{3}-\d{7}$/, 'Phone number must be in the format XXX-XXXXXXX')
    .required('Phone number is required');

const createStringValidation = (minLength: number, maxLength: number) => {
    return yup.string()
        .min(minLength, `Must be at least ${minLength} characters`)
        .max(maxLength, `Must be ${maxLength} characters or less`);
};
const createEmailValidation = () => {
    return yup.string()
        .email('Invalid email address') // Email validation
        .required('Email is required'); // Required field validation
};


export const consumerValidationSchema = yup.object({
    mem_name: createStringValidation(1, 50).required('This field is required'),
    mem_name_nep: createStringValidation(10, 50).required('This field is required'),
    phone: phoneNumberValidation,
    spouse_name: createStringValidation(1, 50).required('This field is required'),
    spouse_name_nep: createStringValidation(1, 50).required('This field is required'),
});

export const authorValidationSchema = yup.object({
    first_name: createStringValidation(1, 150).required('This field is required'),
    last_name: createStringValidation(1, 150).required('This field is required'),
    phone_number: phoneNumberValidation,
    name_nep: createStringValidation(1, 240).required('This field is required'),
    username: createStringValidation(1, 150).required('This field is required'),
    email: createEmailValidation(), // Call the function here
    password: yup.string()
        .min(8, 'Password must be at least 8 characters')
        .required('Password is required'),
    // Confirm password validation
    confirm_password: yup.string()
        .oneOf([yup.ref('password')], 'Passwords must match')
        .required('Confirm Password is required'),
});

export const provinceValidationSchema = yup.object({
    province_name: createStringValidation(1, 50).required('This field is required'),
    province_name_nep: createStringValidation(1, 100).required('This field is required'),
});

export const districtValidationSchema = yup.object({
    district_name: createStringValidation(1, 50).required('This field is required'),
    district_name_nep: createStringValidation(1, 100).required('This field is required'),
});
export const toleValidationSchema = yup.object({
    tole_name: createStringValidation(1, 120).required('This field is required'),
    tole_name_nep: createStringValidation(1, 120).required('This field is required'),
});
export const readerValidationSchema = yup.object({
    reader_name: createStringValidation(1, 120).required('This field is required'),
    reader_name_nep: createStringValidation(1, 120).required('This field is required'),
    reader_add: createStringValidation(1, 60),
    reader_add_nep: createStringValidation(1, 100),
    reader_date: createStringValidation(1, 20).required('This field is required'),
    email: createEmailValidation(),
    reader_pass: createStringValidation(1, 120).required('This field is required'),

});
export const readerEditValidationSchema = yup.object({
    reader_name: createStringValidation(1, 120).required('This field is required'),
    reader_name_nep: createStringValidation(1, 120).required('This field is required'),
    reader_add: createStringValidation(1, 60),
    reader_add_nep: createStringValidation(1, 100),
    email: createEmailValidation(),
});


const createDateValidation = () => {
    return yup.string()
        .matches(/^\d{4}\/\d{2}\/\d{2}$/, 'Date must be in the format YYYY/MM/DD') // Adjust if needed
        .notRequired();
};

export const customerValidationSchema = yup.object({
    mem_name: createStringValidation(1, 120).required('This field is required'),
    mem_name_nep: createStringValidation(1, 220).required('This field is required'),
    spouse_name: createStringValidation(1, 120).required('This field is required'),
    spouse_name_nep: createStringValidation(1, 220).required('This field is required'),
    municipality: yup.number().integer().nullable(), // Assuming this is an ID
    add_nep: createStringValidation(1, 120).nullable(),
    add_eng: createStringValidation(1, 60).nullable(),
    ward_no: yup.number().integer().nullable(),
    district: yup.number().integer().nullable(), // Assuming this is an ID
    sms_mob_no: phoneNumberValidation,
    phone_no: phoneNumberValidation,
    dob: createDateValidation().nullable(),
    ctiz_no: createStringValidation(1, 20).nullable(),
    ctiz_issue_district: yup.number().integer().nullable(), // Assuming this is an ID
    province: yup.number().integer().nullable(), // Assuming this is an ID
    gender: yup.number().integer().nullable(),
    caste: yup.number().integer().nullable(), // Assuming this is an ID
    pan_no: createStringValidation(1, 40).nullable(),
    family_male_no: yup.number().integer().nullable(),
    family_female_no: yup.number().integer().nullable(),
    father_name: createStringValidation(1, 120).nullable(),
    father_name_nep: createStringValidation(1, 220).nullable(),
    grand_father_name: createStringValidation(1, 120).nullable(),
    grand_father_name_nep: createStringValidation(1, 220).nullable(),
    old_sys_no: createStringValidation(1, 10).nullable(),
    reg_date_n: createDateValidation().nullable(),
    meter_conn_date: createDateValidation().nullable(),
    marga_tole: yup.number().integer().nullable(), // Assuming this is an ID
    meter_reading_zone: createStringValidation(1, 20).nullable(),
    serial_no: createStringValidation(1, 20).nullable(),
    serial_suffix: createStringValidation(1, 20).nullable(),
    area_no: yup.number().integer().nullable(),
    meter_status: yup.number().integer().nullable(),
    customer_type: yup.number().integer().nullable(),
    meter_type: yup.number().integer().nullable(),
    tap_type: yup.number().integer().nullable(),
    tap_no: yup.number().integer().nullable(),
    discount_unit: yup.number().integer().nullable(),
    reading_day: yup.number().integer().nullable(),
    meter_sn: createStringValidation(1, 50).nullable(),
    reading_effective: createStringValidation(1, 15).nullable(),
    consumers_no: yup.number().integer().nullable(),
    emi: yup.number().integer().required('This field is required'),
    tap_status: yup.number().integer().nullable(),
    nak_sa_no: yup.number().integer().nullable(),
    kitta_no: yup.number().integer().nullable(),
    area_land: createStringValidation(1, 15).nullable(),
    purja_no: yup.number().integer().nullable(),
    house_no: createStringValidation(1, 15).nullable(),
    sadhiyar_no: yup.number().integer().nullable(),
    branch: yup.number().integer().nullable(),
    active: yup.number().integer().default(0).nullable(),
    block_no: yup.number().integer().nullable(),
    area_supply: createStringValidation(1, 25).nullable(),
    tap_size: yup.number().integer().nullable(), // Assuming this is an ID
    ferrule_meter_distance: createStringValidation(1, 30).nullable(),
    ground_level_ferrule: createStringValidation(1, 30).nullable(),
    distance: createStringValidation(1, 15).nullable(),
    mian_pipe_size: createStringValidation(1, 15).nullable(),
    // photo: yup.mixed().nullable(), // File validation if needed
    // citz_photo: yup.mixed().nullable(), // File validation if needed
    // thumb_photo: yup.mixed().nullable(), // File validation if needed
    // signature1: yup.mixed().nullable(), // File validation if needed
    // lal_purja: yup.mixed().nullable(), // File validation if needed
});


export const proIssuevalidationSchema = yup.object().shape({
    product: yup.string().required('Product is required'),
    member_sn: yup.string().required('This field is required'),
    master_category: yup.string().required('This field is required'),

    issue_qty: yup.number()
      .required('Issue quantity is required')
      .min(1, 'Issue quantity must be at least 1')
      .max(yup.ref('total_issuable'), 'Issue quantity cannot exceed total issuable')
  });
  export const coucherEntryvalidationSchema = yup.object().shape({
    date_en: yup.string().required('This field is required'),
    voucher_type: yup.string().required('This field is required'),
    glid: yup.string().required('This field is required'),
    sglsn: yup.string().required('This field is required'),
    particularid: yup.string().required('This field is required'),
  });
